var map = {
	"./en.json": "Yl9j",
	"./nl.json": "+7rm"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "OP21";


//////////////////
// WEBPACK FOOTER
// ./src/i18n/lang [A-Za-z0-9-_,\s]+\.json$/
// module id = OP21
// module chunks = 103